import { FileOutlined, PlayCircleOutlined } from "@ant-design/icons"
import { Typography } from "antd"
import React from "react"

import { type Attachment } from "../../../../../../Album/types/attachment.types.ts"

interface AlbumThumbnailsProps {
  attachments: Attachment[]
}

const isImage = (mimeType: string) => mimeType?.startsWith("image/")
const isVideo = (mimeType: string) => mimeType?.startsWith("video/")

export const AlbumThumbnails: React.FC<AlbumThumbnailsProps> = ({
  attachments
}) => {
  const attachmentsCount = attachments?.length

  const renderThumbnail = (file: Attachment) => {
    if (isImage(file.mime_type)) {
      return (
        <img
          loading="lazy"
          decoding="async"
          src={file.file}
          alt={file.original_filename}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            display: "block"
          }}
        />
      )
    }

    if (isVideo(file.mime_type)) {
      return (
        <div className="size-full flex flex-col items-center justify-center bg-gray-50">
          <PlayCircleOutlined className="text-3xl text-gray-400" />
          <Typography.Text
            className="text-xs text-gray-400 mt-1 px-2 truncate max-w-full"
            ellipsis={{ tooltip: file.original_filename }}
          >
            {file.original_filename}
          </Typography.Text>
        </div>
      )
    }

    return (
      <div className="size-full flex flex-col items-center justify-center bg-gray-50">
        <FileOutlined className="text-3xl text-gray-400" />
        <Typography.Text
          className="text-xs text-gray-400 mt-1 px-2 truncate max-w-full"
          ellipsis={{ tooltip: file.original_filename }}
        >
          {file.original_filename}
        </Typography.Text>
      </div>
    )
  }

  return (
    <div className="relative grid grid-cols-2 gap-1 p-1 bg-gray-100">
      {attachmentsCount > 0 ? (
        attachments.slice(0, 2).map((file) => (
          <div
            key={file.id}
            className="rounded overflow-hidden bg-white"
            style={{ height: 160 }}
          >
            {renderThumbnail(file)}
          </div>
        ))
      ) : (
        <div className="col-span-2 rounded overflow-hidden bg-white h-40 flex items-center justify-center">
          <FileOutlined className="text-4xl text-gray-300" />
        </div>
      )}
      <div className="absolute bottom-1 left-1 right-1 bg-gradient-to-t from-white to-white/50 text-xs p-2 rounded">
        <Typography.Text>
          {attachmentsCount} {attachmentsCount === 1 ? "file" : "files"}
        </Typography.Text>
      </div>
    </div>
  )
}
